import { Component, ContentChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { FieldPrefixDirective, FieldSuffixDirective } from '@railmybox/shared/directive';

@Component({
  selector: 'eg-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(TextareaComponent)],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class TextareaComponent extends AbstractValueAccessorComponent<string | number> {
  @Input() prefixInputPadding = 10;
  @Input() rows = 1;

  @ContentChild(FieldPrefixDirective, { read: ElementRef }) set prefix(prefix: ElementRef) {
    if (prefix) {
      this.hasPrefixIcon = !!prefix.nativeElement;
      this.prefixContainerWidth = prefix.nativeElement.offsetWidth < 80 ? prefix.nativeElement.offsetWidth : 80;
    }
  }

  @ContentChild(FieldSuffixDirective, { read: ElementRef }) set suffix(suffix: ElementRef) {
    if (suffix) {
      this.hasSuffixIcon = !!suffix.nativeElement;
    }
  }

  hasPrefixIcon = false;
  hasSuffixIcon = false;
  prefixContainerWidth?: number;

  /**
   * Event handler when input is change.
   */
  textareaChanged(): void {
    this.onChange(this.value);
    this.formControl?.setValue(this.value);
    this.changed.emit(this.value);
  }

  onKeyup(event: KeyboardEvent) {
    const value = (event.target as HTMLTextAreaElement).value;
    this.onChange(value);
    this.formControl?.setValue(value);
    this.changed.emit(value);
  }

  onNumberKeyup(_event: KeyboardEvent) {
    this.onChange(this.value);
    this.formControl?.setValue(this.value);
    this.changed.emit(this.value);
  }
}
